import {
    HttpEvent, HttpHandler,
    HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    StatusCodes
} from 'http-status-codes';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private messageService: MessageService, private spinner: NgxSpinnerService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError(error => {
                if (error) {
                    this.spinner.hide();
                    switch (error.status) {
                        case StatusCodes.BAD_REQUEST:
                            if (error.error.errors) {
                                const modalStateErrors = [];
                                for (const key in error.error.errors) {
                                    if (error.error.errors[key]) {
                                        modalStateErrors.push(error.error.errors[key])
                                    }
                                }

                                this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: error.error });
                            } else if (typeof (error.error) === 'object') {
                                this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: error.error });
                            } else {
                                this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: error.error });
                            }
                            break;
                        case StatusCodes.UNAUTHORIZED:
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
                            break;
                        case StatusCodes.NOT_FOUND:
                            this.router.navigateByUrl('/not-found');
                            break;
                        case StatusCodes.INTERNAL_SERVER_ERROR:
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
                            break;
                        default:
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
                            break;
                    }
                }
                return throwError(error);
            })
        )
    }
}